import { defineCustomElement } from '@tyler-components-web/core';
import { ViewComponent } from './view';
export * from './view-constants';
export * from './view';
export function defineViewComponent() {
    defineCustomElement(ViewComponent);
}
